import { TASK_CATEGORY_OPTIONS } from "../../shared/task-category-label/task-category-options.ts";
import { SelectOption } from "../../ui/select/select";
export const PROJECT_OPTIONS: SelectOption[] = [
  { value: "proj1", label: "Project 1" },
  { value: "proj2", label: "Project 2" },
];

export const CATEGORY_OPTIONS: SelectOption[] = TASK_CATEGORY_OPTIONS;

export const MINUTE_OPTIONS: SelectOption[] = [
  { value: "00", label: "00" },
  { value: "15", label: "15" }, 
  { value: "30", label: "30" },
  { value: "45", label: "45" },
];


export const STATUS_OPTIONS: SelectOption[] = [
  { value: "in-progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
]